import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDashboard = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.04199 5.50008V0.916748H15.0837V5.50008H9.04199ZM0.916992 8.41675V0.916748H6.95866V8.41675H0.916992ZM9.04199 15.0834V7.58342H15.0837V15.0834H9.04199ZM0.916992 15.0834V10.5001H6.95866V15.0834H0.916992ZM2.16699 7.16675H5.70866V2.16675H2.16699V7.16675ZM10.292 13.8334H13.8337V8.83342H10.292V13.8334ZM10.292 4.25008H13.8337V2.16675H10.292V4.25008ZM2.16699 13.8334H5.70866V11.7501H2.16699V13.8334Z" })
});
export default SvgDashboard;
